module.exports = __webpack_public_path__ + "baroquescript-webfont.533f8abe3531b330a9e2.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/baroquescript-webfont.woff
// module id = 634
// module chunks = 1